// export const BACKEND_URL = 'http://localhost:8000';
export const BACKEND_URL = 'https://manthrakodi-matrimony-backend-production.up.railway.app';
